module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-about-team",
    attrs: {
      "id": "meet-team"
    }
  }, [_c('div', {
    staticClass: "custom-about-team__container"
  }, [_c('div', {
    staticClass: "custom-about-team__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-about-team__row"
  }, _vm._l((_vm.props.content), function(content, i) {
    return _c('div', {
      key: i,
      staticClass: "custom-about-team__item"
    }, [_c('div', {
      staticClass: "custom-about-team__icon-wrapper"
    }, [_c('div', {
      staticClass: "custom-about-team__icon-outer"
    }, [_c('div', {
      staticClass: "custom-about-team__icon-inner"
    }, [_c('Icon', {
      staticClass: "custom-about-team__icon",
      class: "custom-about-team__icon--" + content.label,
      attrs: {
        "name": content.label
      }
    })], 1)])]), _c('div', {
      staticClass: "custom-about-team__text",
      domProps: {
        "innerHTML": _vm._s(content.text)
      }
    })])
  }), 0), _c('div', {
    staticClass: "custom-about-team__image",
    style: ({
      backgroundImage: 'url(' + _vm.props.img + ')'
    })
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-071df687","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-about-team/custom-about-team.pug
// module id = 669
// module chunks = 1